/**
 * 工程开发基本配置。
 */

module.exports = {
  //API服务器地址
  SERVER: [
    {API_SERVER: "https://zledutestapi.cailian.net", API_PREFIX: "/api-resource"},
    {API_SERVER: "https://financeuatapi.cailian.net", API_PREFIX: "/api-sys"},//
    {API_SERVER: "https://financeuatapi.cailian.net", API_PREFIX: "/api-tax-personal-income-server"},
    {API_SERVER: "https://financeuatapi.cailian.net", API_PREFIX: "/api-finbasic"},
    {API_SERVER: "https://financeuatapi.cailian.net", API_PREFIX: "/api-finance-initial"},
    // {API_SERVER: "https://financeuatapi.cailian.net", API_PREFIX: "/api-sys"},
    // {API_SERVER: "https://financeuatapi.cailian.net", API_PREFIX: "/api-tax-personal-income-server"},
  ],
  //本地webpack开发服务器端口
  DEV_SERVER_PORT: 8086,
  //本地build文件测试服务器端口
  PLAY_SERVER_PORT: 9000,
  ENABLE_API_LOG: false,
  //vue-router 的模式，history or hash
  VUE_ROUTER_MODE: "hash",
  //是否开启mock
  ENABLE_MOCK: false,
  //是否启用webpack bundleAnalyzerPlugin
  ENABLE_BUNDLE_ANALYZER: false,

};



//////////////////
// WEBPACK FOOTER
// ./config/myConfig.js
// module id = rPuG
// module chunks = 13